<script setup lang="ts">
definePageMeta({
  middleware: [(to) => {
    if (to.name === 'privacy') {
      return navigateTo({ name: 'privacy-confidentiality' })
    }
  }],
})

const { t } = useI18n()

const { currentSubRoute, navLinks } = useUseSubPages({
  'privacy-confidentiality': {
    subtitle: t('commons.links.privacy-confidentiality'),
    suptitle: t('commons.privacy'),
    title: t('commons.links.privacy-confidentiality'),
  },
  'privacy-cookies': {
    subtitle: t('commons.links.privacy-cookies'),
    suptitle: t('commons.privacy'),
    title: t('commons.links.privacy-cookies'),
  },
},
)

const { crumbs } = useBreadcrumbs()
</script>

<template>
  <div>
    <AppPageHeader class="bg-gray-50">
      <template #navPages>
        <AppPageNav :links="navLinks" />
      </template>

      <template #breadcrumb>
        <YscBreadcrumbs :crumbs="crumbs">
          <template #default="{ crumb }">
            <NuxtLink
              :to="{ name: crumb.name }"
              class="focus-visible:ring-peacock-500 font-normal hover:underline focus-visible:rounded focus-visible:ring-2 group-last:font-semibold"
              itemprop="item"
            >
              <span itemprop="name">
                {{ crumb.translatedName }}
              </span>
            </NuxtLink>
          </template>
        </YscBreadcrumbs>
      </template>

      <template #suptitle>
        {{ currentSubRoute?.suptitle }}
      </template>

      <template #title>
        {{ currentSubRoute?.title }}
      </template>
    </AppPageHeader>

    <div>
      <NuxtPage :page-key="route => route.fullPath" />
    </div>
  </div>
</template>
